import { GetReviewRequest, GetReviewResponse } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";
import { makeCloudFunction } from "../makeCloudFunction";

export const getReview = makeCloudFunction<GetReviewRequest, GetReviewResponse>(
  "review",
  "getReview",
);
export const useGetReview = makeUseCloudFunction(getReview);
